import { GetModelNameList } from '../apiTypes';
import {
  createHeaderWithCredentials,
  fetchWithAuth,
  getApiUrl,
  getHeader,
} from '../apiUtils';

export interface InspectionCategoryParams {
  categoryId: string;
}

const endPoint = 'model-list';

export const getModelNameList = async (): Promise<GetModelNameList> => {
  const url = getApiUrl(endPoint);
  const header = getHeader({
    method: 'GET',
  });

  const response = await fetchWithAuth(
    url,
    createHeaderWithCredentials(header),
  );
  return response.data;
};
